import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { PrismBadge } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type { ParityManagerIssuesummary } from 'lumen/models';

import styles from './sidebar-item.module.css';

interface ParityParityManagerSidebarItemSignature {
  Args: {
    isSelected?: boolean;
    issueSummary: ParityManagerIssuesummary;
    onIssueSummaryClick: (issueSummaryId: string) => void;
  };
}

const ParityParityManagerSidebarItem = <template>
  <button
    class="button--unstyled p-300 {{styles.sidebar-item}}"
    {{! @glint-expect-error: Incorrect type }}
    selected={{@isSelected}}
    type="button"
    {{! @glint-expect-error: No overload matches this call. }}
    {{on "click" (fn @onIssueSummaryClick @issueSummary.id)}}
  >
    <p class="text-200--bold mb-200">{{@issueSummary.formattedName}}</p>
    <div class="flex items-center justify-between truncate">
      <PrismBadge
        @label={{t "parity.issues" count=@issueSummary.amountIssues}}
      />
      {{#if @issueSummary.escalationinfo.formattedEscalationLevel}}
        <div class="flex items-center justify-start">
          <p class="text-200--regular">
            {{t "parity_manager.escalation_level"}}:
          </p>
          <div class="ml-100">
            <PrismBadge
              @badgeType={{@issueSummary.escalationinfo.escalationBadgeType}}
              @label={{@issueSummary.escalationinfo.formattedEscalationLevel}}
            />
          </div>
        </div>
      {{/if}}
    </div>
  </button>
</template> satisfies TOC<ParityParityManagerSidebarItemSignature>;

export default ParityParityManagerSidebarItem;
